import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();

  // disable logging for production.
  window.console.log = function() { };
}

// Digilocker callback placeholder. Digilocker's SDK calls window.digiCallback(data);
// this only guarantees the global exists so an external call can never hit
// "undefined is not a function". Declared here rather than as an inline <script>
// in index.html so index.html carries no inline script at all — inline scripts are
// blocked outright by a CSP that contains a nonce, since a nonce makes
// 'unsafe-inline' inert. Kept as a no-op: nothing in the app assigns or calls it
// (app.component.ts only has a `declare var`, which emits no JavaScript).
(window as any).digiCallback = (window as any).digiCallback || function (data: any) {};

platformBrowserDynamic().bootstrapModule(AppModule);
